<template>
  <section class="Events" id="Events">
    <div class="events_wrapper">
      <div class="title_wrapper">
        <h1 class="title">
          Eventos
        </h1>
      </div>
      <div v-if="!orderedEventList.length" class="empty_events">
        <div class="empty_events_wrapper">
          <div class="square">
          </div>
          <p>
            No se encontraron eventos
          </p>
        </div>
      </div>
      <div v-show="orderedEventList.length" class="events_list">
        <div class="swiper-container events">
          <div class="swiper-wrapper">
            <article class="swiper-slide" v-for="event in orderedEventList" :key="event.id">
              <img loading="lazy" :src="event.url" />
              <div class="top">
                <small>{{event.datetime | moment('DD MMM [de] YYYY')}}</small>
                <h1 class="ellipse row2"> {{event.name}} </h1>
              </div>
              <div class="bottom">
                <p class="ellipse row2"> {{event.description}} </p>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.min.css'
import { firestore } from '@/main'
import moment from 'moment'

Swiper.use([Navigation, Pagination]);

export default {
  data: () => ({
    offsetStart: 0,
    mySwiper: null,
    eventsList: []
  }),
  mounted () {
    this.getOffset()
    this.mySwiper = new Swiper('.swiper-container.events', {
      slidesPerView: 5,
      spaceBetween: 30,
      slidesOffsetBefore: this.offsetStart,
      slidesOffsetAfter: this.offsetStart,
      observer: true,
      observeParents: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 25,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        400: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        760: {
          slidesPerView: 3,
        },
        980: {
          slidesPerView: 4,
        },
        1200: {
          slidesPerView: 5,
        },
        // 1700: {
        //   slidesPerView: 3,
        // },
        // 1900: {
        //   slidesPerView: 3,
        // },
      }
    })

    this.getAllEvents()
  },
  methods: {
    getAllEvents () {
      firestore.collection("events").get()
      .then((snap) => {
        snap.forEach((doc) => {
          const data = doc.data()
          this.eventsList.push({
            id: doc.id,
            name: data.name,
            datetime: data.datetime,
            description: data.description,
            url: data.url
          })
        })
      })
      .catch(console.error)
    },
    getOffset () {
      const title = document.querySelector('#objectives_title')
      this.offsetStart = title.getBoundingClientRect().left
      window.addEventListener('resize', () => {
        if (window.innerWidth > 760) {
          this.mySwiper.params.slidesOffsetBefore = title.getBoundingClientRect().left
          this.mySwiper.params.slidesOffsetAfter = title.getBoundingClientRect().left
        }
      })
    }
  },
  computed: {
    orderedEventList () {
      return this.eventsList.slice(0).sort((a, b) => {
        if (moment(a.datetime) > moment(b.datetime)) return 1
        if (moment(a.datetime) < moment(b.datetime)) return -1
      })
      // return this.eventsList.slice(0).sort((a, b) => { moment(a.datetime).diff(b.datetime) < 0  })
    }
  }
}
</script>

<style scoped lang="sass">
@import '../assets/css/app.sass'
.Events
  background-color: $primary_color
  height: 700px
  overflow: hidden
  .events_wrapper
    opacity: 1
    transition: all ease-in-out .5s .5s
    position: relative
    .empty_events
      display: flex
      justify-content: center
      align-items: center
      .empty_events_wrapper
        display: flex
        flex-direction: column
        align-items: center
        margin-top: 12rem
        .square
          height: 20px
          width: 20px
          margin-left: -30px
          background-color: $accent_color
          position: relative
          &:before
            position: relative
            content: ''
            display: block
            right: -20px
            bottom: -20px
            width: 20px
            height: 20px
            background-color: $secondary_color
        p
          margin-top: 50px
          color: #546397
          font-family: $font
          width: 200px
          text-align: center
          line-height: 1.6
          font-size: 13px
    .swiper-container
      overflow: inherit
    .title_wrapper
      display: flex
      justify-content: flex-start
      padding-left: 70px
      box-sizing: border-box
      width: 980px
      padding-top: 7rem
      margin: 0 auto
    .events_list
      margin-top: 80px
      position: relative
      z-index: 20
      .events
        left: 0
        top: 0
      article
        background-color: white
        box-sizing: border-box
        height: 320px
        font-family: $font
        color: $primary_color
        display: flex
        flex-direction: column
        img
          width: 100%
          height: 170px
          object-fit: cover
        .top
          padding: 20px
          padding-bottom: 10px
          z-index: 5
          h1
            font-size: 16px
            font-weight: 700
            line-height: 1.4
          small
            font-size: 12px
            letter-spacing: 1px
            margin-bottom: 5px
            display: block
            color: $primary_color
        .bottom
          padding: 20px
          padding-top: 0
          z-index: 5
          p
            font-size: 13px
            line-height: 1.6
            color: $primary_color
            font-family: $font_text

@media screen and (max-width: 980px)
  .Events
    height: 550px
    .events_wrapper
      .title_wrapper
        width: 760px
        padding-top: 5rem
      .events_list
        margin-top: 50px
        article
          // height: 220px

@media screen and (max-width: 760px)
  .Events
    .events_wrapper
      .title_wrapper
        width: 480px

@media screen and (max-width: 560px)
  .Events
    .events_wrapper
      .title_wrapper
        width: 320px

@media screen and (max-width: 400px)
  .Events
    .events_wrapper
      width: 100%
      padding:
        left: 40px
        right: 40px
      box-sizing: border-box
      align-items: flex-start
      .title_wrapper
        width: 100%
        padding-left: 0
        justify-content: flex-start
</style>